var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"insights-alerts col-12"},[_c('Breadcrumb',{attrs:{"items":_vm.breadcrumbItems}}),_c('InsightsCardsBlock')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }